import { Injectable } from '@angular/core'
import { Observable } from 'rxjs/Observable'
import { LectureApiBase } from '../lecture-api'
import { Area } from '../../models'

@Injectable()
export abstract class AreaApi {
  abstract apiPath(resourceId: number, areaId?)

  constructor(
    private api: LectureApiBase,
  ) {}

  index(resourceId: number): Observable<Area[]> {
    return this.api.listWithObject(Area, this.apiPath(resourceId))
  }

  all(resourceId: number, groupIds?: number[]): Observable<Area[]> {
    return this.api.listWithObject(Area, this.api.makeUrlWithParams(`${this.apiPath(resourceId, 'all')}`, { groupIds }))
  }

  group(resourceId: number): Observable<Area[]> {
    return this.api.listWithObject(Area, `${this.apiPath(resourceId, 'group')}`)
  }

  post(resourceId: number, originX: number, originY: number, width: number, height: number): Observable<Area> {
    return this.api.postWithObject(Area, this.apiPath(resourceId),
      {
        area: {
          originX: originX,
          originY: originY,
          width: width,
          height: height
        }
      }
     )
  }

  directPost(resourceId: number, payload: any): Observable<Area> {
    return this.api.postWithObject(Area, this.apiPath(resourceId),
      {
        direct: true,
        area: payload
      }
    )
  }

  delete(resourceId: number, areaId: number): Observable<any> {
    return this.api.delete(this.apiPath(resourceId, areaId.toString()))
  }
}



// WEBPACK FOOTER //
// ./src/apis/area/base.ts